// =============================================================================
// features/sales/agenda/AgendaTabs.tsx — Abas Agora/Hoje/Próximos/Concluídos
// (doc 26 §6.1). Mesmo padrão de tabs de features/ai-actions/AiActionsPage.tsx
// (WindowTabs) — pill group com aba ativa em elev-1.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../lib/cn';

import { AGENDA_TABS, type AgendaTab } from './buckets';

export interface AgendaTabsProps {
  value: AgendaTab;
  onChange: (tab: AgendaTab) => void;
}

export function AgendaTabs({ value, onChange }: AgendaTabsProps): React.JSX.Element {
  return (
    <div
      role="tablist"
      aria-label="Recorte da agenda"
      className="inline-flex gap-1 p-1 rounded-md border border-border w-fit bg-surface-2"
    >
      {AGENDA_TABS.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={cn(
              'px-3 py-1.5 rounded-sm font-sans text-sm font-semibold',
              'min-h-[36px]',
              'transition-colors duration-fast ease-out',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azul/20',
              active ? 'bg-surface-1 text-azul' : 'text-ink-3 hover:text-ink',
            )}
            style={active ? { boxShadow: 'var(--elev-1)' } : undefined}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
